/**
 * Returns a stable session ID for statistics tracking.
 * Persists in sessionStorage for the browser session duration.
 */
export function useStatisticsSession(): string {
  const key = 'mychar_session_id'

  if (import.meta.server) {
    return crypto.randomUUID()
  }

  let id = sessionStorage.getItem(key)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(key, id)
  }
  return id
}
